import styles from "./History.module.css";
import { useState, useEffect, useContext } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../url";
import { AuthContext, AuthContextType } from "../../Auth";

export type HistoryData = {
  order_id: number;
  order_at: string;
  supplier: string;
  totalprice: number;
  office: string;
  username: string;
  receiveDate: string | null;
};

export default function History() {
  const navigate = useNavigate();

  const [historydata, setHistorydata] = useState<HistoryData[]>([]);
  const { auth, setAuth } = useContext(AuthContext) as AuthContextType;
  const [office, setOffice] = useState<string>(auth.office || "函館店");
  const [reload, setReload] = useState<boolean>(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${baseUrl}/checkAuth`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (!data.result) {
          console.log("Not authenticated");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        const response2 = await fetch(`${baseUrl}/getusersdata`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: data.username }),
        });
        const data2 = await response2.json();
        console.log(
          "Authenticated user:",
          data.username,
          "Office:",
          data2.office,
          "Authority:",
          data2.authority
        );
        setAuth({
          username: data.username,
          isAuthenticated: true,
          office: data2.office,
          authority: data2.authority,
        });
      } catch (error) {
        console.error(error);
      }
    };
    checkAuth();
  }, [navigate, setAuth]);

  useEffect(() => {
    const param = new URLSearchParams({ office: office });
    const fetchHistory = async () => {
      const response = await fetch(
        `${baseUrl}/gethistory?${param.toString()}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      let data = await response.json();
      const dayofweek = [
        "（日）",
        "（月）",
        "（火）",
        "（水）",
        "（木）",
        "（金）",
        "（土）",
      ];
      for (let i = 0; i < data.length; i++) {
        const utcDate = new Date(data[i].order_at);
        const utcReceiveDate = new Date(data[i].receiveDate);
        const convert = (dateItem: Date) => {
          const japanOffset = 9 * 60 * 60 * 1000;
          const japanDate = new Date(dateItem.getTime() + japanOffset);
          const year = japanDate.getFullYear();
          const month = japanDate.getMonth() + 1;
          const date = japanDate.getDate();
          const day = dayofweek[japanDate.getDay()];
          const hours = japanDate.getHours();
          const minutes = japanDate.getMinutes();
          const seconds = japanDate.getSeconds();
          const convertDate = {
            date: `${year}年${month}月${date}日${day}`,
            time: `${hours}: ${minutes}: ${seconds}`,
          };
          return convertDate;
        };
        const appeardate = convert(utcDate);
        data[i].order_at = appeardate.date + appeardate.time;
        if (data[i].receiveDate) {
          const appearReceivedate = convert(utcReceiveDate);
          data[i].receiveDate = appearReceivedate.date;
        }
      }
      setHistorydata(data);
    };
    fetchHistory();
  }, [office]);

  const handleDetail = (index: number) => {
    const Ordered = historydata[index];
    navigate("/HistoryDetail", { state: Ordered });
  };

  const handleEntering = async (index: number) => {
    const enteringConfirm = window.confirm(
      "入庫処理をせずに、入庫日のみを登録します。よろしいですか？"
    );
    if (enteringConfirm) {
      try {
        const response = await fetch(`${baseUrl}/submitentering`, {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ order_id: historydata[index].order_id }),
        });
        const data = await response.json();
        if (data.isAuth === false) {
          alert("セッションが切れました。再度ログインしてください");
          setAuth({
            username: null,
            isAuthenticated: false,
            office: undefined,
            authority: "user",
          });
          return navigate("/login");
        }
        console.log(data);
        alert("入庫日を登録しました。");
        setReload(!reload);
      } catch (error) {
        console.error(error);
      }
    } else {
      alert("登録をキャンセルしました。");
    }
  };

  const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setOffice(e.target.value);
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>発注履歴</h2>
      <div className={styles.scroll}>
        <div className={styles.selectWrapper}>
          <label htmlFor="支店" className={styles.label}>
            支店:
            <select
              value={office}
              id="支店"
              onChange={handleOffice}
              className={styles.select}
            >
              <option value="函館店">函館店</option>
              <option value="札幌店">札幌店</option>
              <option value="釧路店">釧路店</option>
              <option value="室蘭店">室蘭店</option>
            </select>
          </label>
        </div>
        {historydata.length > 0 ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.th}>発注日時</th>
                <th className={styles.th}>発注元</th>
                <th className={styles.th}>発注者</th>
                <th className={styles.th}>発注先</th>
                <th className={styles.th}>金額</th>
                <th className={styles.th}>入庫日</th>
              </tr>
            </thead>
            <tbody>
              {historydata.map((item: HistoryData, index: number) => (
                <tr key={index} className={styles.tr}>
                  <td className={styles.td}>{item.order_at}</td>
                  <td className={styles.td}>{item.office}</td>
                  <td className={styles.td}>{item.username}</td>
                  <td className={styles.td}>{item.supplier}</td>
                  <td className={styles.td}> &yen;{item.totalprice}</td>
                  <td className={styles.td}>{item.receiveDate}</td>
                  <td className={styles.td2}>
                    <Button
                      sx={{
                        fontSize: 14,
                        minWidth: 0,
                        "@media screen and (max-width:959px)": {
                          fontSize: 12,
                          width: 90,
                        },
                      }}
                      onClick={() => handleDetail(index)}
                    >
                      注文明細
                    </Button>
                  </td>
                  <td className={styles.td3}>
                    <Button
                      onClick={() => handleEntering(index)}
                      disabled={!!item.receiveDate}
                      sx={{
                        fontSize: 14,
                        margin: 0,
                        "@media screen and (max-width:959px)": {
                          fontSize: 12,
                          width: 110,
                        },
                      }}
                    >
                      入庫日を登録
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className={styles.div2}>該当する発注履歴はありません。</div>
        )}
      </div>
    </div>
  );
}
